'use client'

import { FC, ReactNode, CSSProperties } from 'react'
import { Box, Fade, Modal as MModal, Typography, iconButtonClasses, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Close22, Close36 } from '@/components/icons'
import { useMediaQuery, Theme } from '@mui/material'

interface ModalSmallProps {
  isOpen: boolean
  onClose?: () => void
  title?: string
  children: ReactNode
  hideCloseButton?: boolean
  isSlim?: boolean
  stickToBottom?: boolean
  contentStyle?: CSSProperties
}

const Overlay = styled(MModal)`
  display: flex;
  align-items: center;
  justify-content: center;
`

const Card = styled(Box)`
  background: ${({ theme }) => theme.custom.colors.common.white};
  border-radius: 16px;
  box-shadow: 0px 12px 40px rgba(0, 0, 0, 0.25);
  padding: 32px 32px 28px 32px;
  max-width: calc(100vw - 32px);
  position: relative;
  width: 1200px;
`

const Title = styled(Typography)`
  text-align: center;
  font-weight: 700;
  font-size: 28px;
  line-height: 36px;
`

const CloseButton = styled(IconButton)(({ theme }) => ({
  [`&.${iconButtonClasses.root}`]: {
    color: theme.custom.colors.common.black,
  },
}))

export const ModalSmall: FC<ModalSmallProps> = ({
  isOpen,
  onClose,
  title,
  children,
  hideCloseButton = false,
  isSlim = false,
  stickToBottom = false,
  contentStyle,
}) => {
  const isLarge = useMediaQuery<Theme>((theme) => theme.breakpoints.up('sm'))

  return (
    <Overlay
      open={isOpen}
      onClose={onClose}
      sx={{ alignItems: stickToBottom ? 'flex-end' : 'center', paddingBottom: stickToBottom ? '67px' : 0 }}
    >
      <Fade in={isOpen}>
        <Card sx={{ padding: isSlim ? '16px' : '32px', borderRadius: '6px', ...contentStyle }}>
          {!hideCloseButton && onClose && (
            <Box sx={{ position: 'absolute', right: 12, top: 12 }}>
              <CloseButton size={isLarge ? 'medium' : 'small'} onClick={onClose}>
                {isLarge ? <Close36 /> : <Close22 />}
              </CloseButton>
            </Box>
          )}
          {title && <Title variant="h2">{title}</Title>}
          <Box sx={{ pt: title ? 2 : 0 }}>{children}</Box>
        </Card>
      </Fade>
    </Overlay>
  )
}

export default ModalSmall
